import styled from 'styled-components';

export const StyledMarkdownOutput = styled.div`
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    width: 100%;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;

    * {
        font-size: inherit !important;
        line-height: inherit !important;
    }

    a {
        color: inherit !important;
    }
    
    p:last-child {
        margin-bottom: 0;
    }
`;
